import {Component, ViewContainerRef, OnInit, ViewEncapsulation} from '@angular/core';
import {Constants} from "../../services/constants";
import {TenantService} from "../../services/tenant.service";
import {Router, NavigationEnd} from "@angular/router";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  private window: Window;
  private viewContainerRef: ViewContainerRef;
  isHeaderHidden = false;

  constructor(private router: Router,
              viewContainerRef: ViewContainerRef,
              private userService: UserService,
              private tenantService: TenantService) {

    this.viewContainerRef = viewContainerRef;
    Constants.router = this.router;
    this.window = window;
    Constants.setup(this.window);

  }

  ngOnInit(): void {
    this.setHeaderDisplay();
    this.tenantService.subscribeForTenant()
      .subscribe(tenant => {
        this.injectCss();
        this.injectTitle(tenant['storeTitle']);
        this.injectFavicon(tenant['faviconUrl']);
      });
    this.tenantService.getTenant();
  }

  private injectCss() {
    let head = this.window.document.head;
    let link = this.window.document.createElement("link");
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = this.tenantService.getCssUrl();

    head.appendChild(link);
  }

  private injectTitle(storeTitle: string) {
    let head = this.window.document.head;
    let title = this.window.document.createElement("title");
    title.text = storeTitle;
    head.appendChild(title);
  }

  private injectFavicon(faviconUrl: string) {
    let head = this.window.document.head;
    let favicon = this.window.document.createElement("link");
    favicon.href = faviconUrl;
    favicon.rel = "icon";
    favicon.type = "image/x-icon";
    head.appendChild(favicon);
  }
  private setHeaderDisplay() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (event.url.indexOf("/buyer") > -1) {
          this.isHeaderHidden = true;
        } else {
          this.isHeaderHidden = false;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/main/app.component.ts